export default __webpack_public_path__ + "bc6904d7215f7c4c4989ca07f3ee0917.png";